export default __webpack_public_path__ + "static/5905v5907_3-146cd2d55809f90bf135f63de1219c0d.webp";